export const ContinueAsRecruiterExperimentKey = 'KRK-882_continue_as_recruiter';
export const continueAsRecruiter = {
    [ContinueAsRecruiterExperimentKey]: {
        experimentId: '5142621207658496',
        variantsIds: {
            A: '4996592235708416', // Original
            B: '4734335106940928', // Variation #1
        },
    },
};
//# sourceMappingURL=continueAsRecruiter.js.map